import { PaymentType } from "@1games-ru/region-shared/dist/enums/payment/payment";
import { FridgeEntityDto } from "@1games-ru/region-shared/dist/types/fridge/fridge";
import { range } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { BankCardIcon, CashIcon } from "@/shared/icons";
import { DELIVERY_PRDUCTS_STEP } from "@/domains/estate/constants/constants";
import useFridgeHandlers from "@/domains/estate/hooks/handlers/useFridgeHandlers";

export default function useFridgeDelivery(fridge: FridgeEntityDto | null) {
  const [openDeliveryModal, setOpenDeliveryModal] = useState(false);
  const [productsForDelivery, setProductsForDelivery] = useState(DELIVERY_PRDUCTS_STEP);
  const [methodPaymnetDelivery, setMethodPaymentDelivery] = useState(PaymentType.Card);
  const { createOrderDelivery, isCreateOrderDelivery } = useFridgeHandlers();
  const { t } = useTranslation("estate");

  const productsValues = useMemo(() => {
    if (!fridge) return [];
    return range(
      DELIVERY_PRDUCTS_STEP,
      fridge.capacity - fridge.materials + DELIVERY_PRDUCTS_STEP,
      DELIVERY_PRDUCTS_STEP,
    ).map((item) => ({
      label: String(item),
      value: item,
    }));
  }, [fridge]);

  const paymentMethods = useMemo(
    () => [
      { value: PaymentType.Card, label: t("estate.fridge.card"), icon: BankCardIcon },
      { value: PaymentType.Cash, label: t("estate.fridge.cash"), icon: CashIcon },
    ],
    [t],
  );

  const onCreateDelivery = useCallback(async () => {
    if (!fridge) return false;

    const result = await createOrderDelivery({
      id: fridge.id,
      paymentMethod: methodPaymnetDelivery,
      restockAmount: productsForDelivery,
    });
    if (result) setOpenDeliveryModal(false);

    return result;
  }, [createOrderDelivery, fridge, methodPaymnetDelivery, productsForDelivery]);

  useEffect(() => {
    if (!openDeliveryModal) {
      setProductsForDelivery(DELIVERY_PRDUCTS_STEP);
      setMethodPaymentDelivery(PaymentType.Card);
    }
  }, [openDeliveryModal, fridge]);

  const priceDelivery = useMemo(
    () =>
      fridge ? (fridge.deliveryPricePerTenth * productsForDelivery) / DELIVERY_PRDUCTS_STEP : 0,
    [fridge, productsForDelivery],
  );

  return {
    openDeliveryModal,
    setOpenDeliveryModal,
    productsForDelivery,
    setProductsForDelivery,
    productsValues,
    methodPaymnetDelivery,
    setMethodPaymentDelivery,
    paymentMethods,
    priceDelivery,
    onCreateDelivery,
    isCreateOrderDelivery,
  };
}
